<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>工厂列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="工厂编号" prop="factoryCode">
                <el-input v-model="searchform.factoryCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工厂类别" prop="factoryType">
                <el-select
                  v-model="searchform.factoryType"
                  style="width:100%"
                  placeholder="请选择工厂类别"
                >
                  <el-option
                    v-for="(item,index) in searchfactory_type"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" style="margin-left:10px">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['plantlist_select']"
              >搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="dialogVisible = true"
                v-permission="['plantlist_add']"
              >新建工厂</el-button>
              <el-button
                v-permission="['plantlist_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            border
            style="width:100%"
            @cell-click="danhang"
          >
            <el-table-column prop="factory_code" label="工厂编号"></el-table-column>
            <el-table-column prop="factory_name" label="工厂名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="factory_type_name" label="工厂类别"></el-table-column>
            <el-table-column prop="factory_address" label="地址" show-overflow-tooltip></el-table-column>
            <el-table-column prop="relation_depart_code" label="关联部门编码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="action" label="操作" min-width="130">
              <el-button-group>
                <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="update()"
                  v-permission="['plantlist_update']"
                >修改</el-button>
                <el-button
                  type="danger"
                  plain
                  size="mini"
                  @click="deletedata()"
                  v-permission="['plantlist_delete']"
                >删除</el-button>
                <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="tiaozhuan()"
                  v-permission="['plantlist_link']"
                >车间列表</el-button>
              </el-button-group>
            </el-table-column>
          </el-table>
          <br />
          <!-- 编辑修改出框 -->
          <el-dialog title="编辑" :visible.sync="editVisible" center width="30%">
            <el-form :model="form" ref="form" label-width="100px" :rules="rules">
              <el-row>
                <el-form-item label="工厂编号" prop="factory_code">
                  <el-input v-model="form.factory_code" clearable style="width:80%"></el-input>
                </el-form-item>
                <el-form-item label="工厂名称" prop="factory_name">
                  <el-input v-model="form.factory_name" style="width:80%"></el-input>
                </el-form-item>
                <el-form-item label="关联部门编码" prop="relation_depart_code">
                  <el-cascader
                    clearable
                    v-model="form.relation_depart_code"
                    style="width:80%"
                    :props="elselectProps"
                    :show-all-levels="true"
                    :options="departtree"
                  />
                </el-form-item>
                <el-form-item label="工厂类别" prop="factory_type">
                  <el-select v-model="form.factory_type" style="width:80%" placeholder="请选择账号状态">
                    <el-option
                      v-for="item in factory_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="地址" prop="factory_address">
                  <el-input v-model="form.factory_address" clearable style="width:80%"></el-input>
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit('form')">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 新增弹出框 -->
          <el-dialog
            title="添加"
            :visible.sync="dialogVisible"
            @close="resetForm('formadd')"
            width="28%"
            :modal="true"
            center
          >
            <el-form
              :model="formadd"
              :rules="rules"
              ref="formadd"
              label-width="100px"
              style="margin-left:15%"
            >
              <el-row>
                <el-form-item label="工厂编号" prop="factory_code">
                  <el-input v-model="formadd.factory_code" style="width:80%"></el-input>
                </el-form-item>
                <el-form-item label="工厂名称" prop="factory_name">
                  <el-input v-model="formadd.factory_name" style="width:80%"></el-input>
                </el-form-item>
                <el-form-item label="关联部门编码" prop="relation_depart_code">
                  <!-- <el-input v-model="formadd.relation_depart_code" style="width:80%"></el-input> -->
                  <el-cascader
                    v-model="formadd.relation_depart_code"
                    style="width:80%"
                    :props="elselectProps"
                    :show-all-levels="true"
                    :options="departtree"
                  />
                </el-form-item>
                <el-form-item label="工厂类别" prop="factory_type">
                  <el-select
                    v-model.number="formadd.factory_type"
                    style="width:80%"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in factory_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="地址" prop="factory_address">
                  <el-input v-model="formadd.factory_address" style="width:80%"></el-input>
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button @click="resetForm('formadd')">重置</el-button>
              <el-button type="primary" @click="submitadd('formadd')">确 定</el-button>
            </span>
          </el-dialog>
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[20,30,40,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
          <el-divider></el-divider>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  factorylist,
  factoryadd,
  factorydelete,
  factoryupdate
} from "@/api/plant";
import { list } from "@/api/orgin";
import { construct, destruct } from "@aximario/json-tree";
//引入导出组件模块
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
    this.getdeparttree();
  },
  data() {
    return {
      // 下拉数据
      factory_type: [
        {
          value: 0,
          label: "自有工厂"
        },
        {
          value: 1,
          label: "外协工厂"
        }
      ],
      searchfactory_type: [
        {
          value: 0,
          label: "自有工厂"
        },
        {
          value: 1,
          label: "外协工厂"
        }
      ],
      //基础数据
      dialogVisible: false,
      editVisible: false,
      tableData: [],
      factorysublist: [],
      relation_depart_codelist: [],
      departtree: null,
      elselectProps: {
        children: "listSubDepartments",
        label: "depart_name",
        value: "depart_code",
        id: "depart_uuid",
        checkStrictly: true
      },
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        factory_uuid: null,
        factoryName: null,
        factoryCode: null,
        factoryType: null,
        factory_address: null
      },
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //修改表单数据
      form: {
        factory_uuid: "",
        factory_name: "",
        factory_code: "",
        factory_type: "",
        factory_address: "",
        relation_depart_code: []
      },
      //新增弹窗变量begin
      //表单数据
      formadd: {
        factory_uuid: "",
        factory_name: "",
        factory_code: "",
        factory_type: "",
        factory_address: "",
        relation_depart_code: []
      },
      //基础表单验证
      rules: {
        relation_depart_code: [
          { required: true, message: "请选择关联部门编码", trigger: "blur" }
        ],
        factory_name: [
          { required: true, message: "请输入工厂名称", trigger: "blur" }
        ],
        factory_code: [
          { required: true, message: "请输入工厂编号", trigger: "blur" },
          { validator: this.ifbianma, trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" }
        ],
        factory_type: [
          { required: true, message: "请选择工厂类别", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    // 验证编码方法
    ifbianma(rule, value, callback) {
      if (this.dialogVisible) {
        factorylist({ factoryCode: value }).then(response => {
          if (response.data.data.length >= 1) {
            callback(new Error("编码不能重复"));
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      factorylist(obj).then(response => {
        this.tableData = response.data.data;
        for (let i = 0; i < this.tableData.length; i++) {
          switch (this.tableData[i].factory_type) {
            case 0:
              this.tableData[i].factory_type_name = "自有工厂";
              break;
            case 1:
              this.tableData[i].factory_type_name = "外协工厂";
              break;
            default:
              break;
          }
        }
        this.total_count = response.data.total_count;
        this.currentPage = response.data.page_index;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    //新增保存提示
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          this.dialogVisible = false;
          factoryadd({
            factory_sub_code: this.formadd.factory_sub_code,
            factory_name: this.formadd.factory_name,
            factory_code: this.formadd.factory_code,
            factory_type: this.formadd.factory_type,
            factory_address: this.formadd.factory_address,
            relation_depart_code: this.formadd.relation_depart_code[
              this.formadd.relation_depart_code.length - 1
            ]
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.resetForm(formName);
              this.Tabledata();
              console.log(this.formadd.account_status);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.currentPage = pageIndex;
      this.Tabledata({
        factory_uuid: this.searchform.factory_uuid,
        factoryName: this.searchform.factoryName,
        factoryCode: this.searchform.factoryCode,
        factoryType: this.searchform.factoryType,
        factory_address: this.searchform.factory_address,
        pageIndex: this.currentPage
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.Tabledata({ pageSize });
    },
    //表格单行点击
    danhang(row) {
      this.form.relation_depart_code = [];
      this.form.factory_sub_code = row.factory_sub_code;
      this.form.factory_name = row.factory_name;
      this.form.factory_code = row.factory_code;
      this.form.factory_type = row.factory_type;
      this.form.factory_address = row.factory_address;
      this.form.factory_uuid = row.factory_uuid;
      if (row.relation_depart_code) {
        this.form.relation_depart_code.push(row.relation_depart_code);
      }
      console.log(this.form.relation_depart_code);
      console.log(row);
    },
    // 修改弹窗保存       请求接口！！
    submit(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          this.editVisible = false;
          factoryupdate({
            factory_sub_code: this.form.factory_sub_code,
            factory_uuid: this.form.factory_uuid,
            factory_name: this.form.factory_name,
            factory_code: this.form.factory_code,
            factory_type: this.form.factory_type,
            factory_address: this.form.factory_address,
            relation_depart_code: this.form.relation_depart_code[
              this.form.relation_depart_code.length - 1
            ]
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "修改成功!"
              });
              this.currentchange(this.currentPage);
            } else {
              this.$message({
                type: "woring",
                message: "修改失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改按钮弹窗
    update() {
      setTimeout(() => {
        this.editVisible = true; //弹窗false关闭 true开启
      }, 200);
    },
    //删除按钮事件
    deletedata() {
      this.$confirm("此操作将永久删除该工厂信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          factorydelete({
            factory_uuid: this.form.factory_uuid
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.Tabledata();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        factory_uuid: this.searchform.factory_uuid,
        factoryName: this.searchform.factoryName,
        factoryCode: this.searchform.factoryCode,
        factoryType: this.searchform.factoryType,
        factory_address: this.searchform.factory_address
      };
      factorylist(obj).then(response => {
        this.tableDataDownload = response.data.data;
        for (let i = 0; i < this.tableDataDownload.length; i++) {
          switch (this.tableDataDownload[i].factory_type) {
            case 0:
              this.tableDataDownload[i].factory_type_name = "自有工厂";
              break;
            case 1:
              this.tableDataDownload[i].factory_type_name = "外协工厂";
              break;
            default:
              break;
          }
        }

        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "工厂编号",
            "工厂名称",
            "工厂类别",
            "地址"
          ];
          const filterVal = [
            "factory_code",
            "factory_name",
            "factory_type_name",
            "factory_address"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      setTimeout(() => {
        this.$route.query.factory_code = this.form.factory_code;
        this.$router.push({
          path: "/workshoplist",
          query: { factory_code: this.form.factory_code }
        });
      }, 100);
    },
    getdeparttree(obj) {
      this.form.relation_depart_codelist = [];
      list().then(response => {
        this.departtree = construct(response.data, {
          id: "depart_uuid",
          pid: "parent_uuid",
          children: "listSubDepartments"
        });
        const id = 1000;
      });
    }
  }
};
</script>
<style scoped>
</style>
